// https://vuex.vuejs.org/en/state.html

import cookies from 'vue-cookies'

export default {
  authStatus: '',
  token: cookies.get('token') || '',
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
  tableList: [],
  city: localStorage.getItem('city') ? JSON.parse(localStorage.getItem('city')) : {},
  spinning: false
}
